import { useDisclosure } from '@hooks/use-disclosure';
import { useCallback } from 'react';

interface UseTncDialogHandler {
  onReject: () => void;
}

function useTncDialogHandler({ onReject }: UseTncDialogHandler) {
  const { onClose, isOpen, onOpen } = useDisclosure();

  const onAcceptTnc = useCallback(() => {
    onClose();
  }, [onClose]);

  const onRejectTnc = useCallback(() => {
    onReject();
    onClose();
  }, [onClose, onReject]);

  return { onClose, isOpen, onOpen, onAcceptTnc, onRejectTnc };
}

export default useTncDialogHandler;
